import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import Home from "./Home/Home";
import Landing from "./Landing/Landing";
import Invoice from "./Dashboard/Pages/Invoice/Invoice";
import Rewards from "./Dashboard/Pages/Rewards/Rewards";
import Wallets from "./Dashboard/Pages/Wallets/Wallets";
import Profile from "./Dashboard/Pages/Profile/Profile";
import Guides from "./Dashboard/Pages/Guides/Guides";

export default function Router() {
  return (
    <Routes>
      {/* <Route path="/" element={<Home />} /> */}
      {/* <Route path="dashboard/*" element={<Dashboard />} /> */}
      <Route path="landing" element={<Landing />} />

      <Route path="/" index element={<Invoice />} />
      <Route path="dashboard/rewards" element={<Rewards />} />
      <Route path="dashboard/wallets" element={<Wallets />} />
      <Route path="dashboard/profile" element={<Profile />} />
      <Route path="dashboard/guides" element={<Guides />} />
    </Routes>
  );
}
